/*!
 * ignore
 */

module.exports = require('bson').Decimal128;
